<template>
  <b-row>
    <b-col
      cols="12"
      xl="6"
    >
      <h6 class="text-center">
        {{ leftHeading }}
      </h6>
      <b-list-group>
        <draggable
          v-model="$leftFields"
          group="fields"
        >
          <b-list-group-item
            v-for="field in $leftFields"
            :key="field.column"
            class="text-truncate"
          >
            {{ field.name }}
          </b-list-group-item>
          <b-list-group-item
            v-if="$leftFields.length === 0"
            class="placeholder"
          >
            ...drag a field here...
          </b-list-group-item>
        </draggable>
      </b-list-group>
    </b-col>

    <b-col
      cols="12"
      xl="6"
    >
      <h6 class="text-center">
        {{ rightHeading }}
      </h6>
      <b-list-group>
        <draggable
          v-model="$rightFields"
          group="fields"
        >
          <b-list-group-item
            v-for="field in $rightFields"
            :key="field.column + '-right'"
            class="text-truncate"
          >
            {{ field.name }}
          </b-list-group-item>
          <b-list-group-item
            v-if="$rightFields.length === 0"
            class="placeholder"
          >
            ...drag a field here...
          </b-list-group-item>
        </draggable>
      </b-list-group>
    </b-col>
  </b-row>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import draggable from 'vuedraggable'

const components = {
  draggable,
}

const props = {
  leftHeading: {
    type: String,
    default: null,
  },
  rightHeading: {
    type: String,
    default: null,
  },
  leftFields: {
    type: Array as PropType<{ column:string, name:string }[]>,
    default: () => [],
  },
  rightFields: {
    type: Array as PropType<{ column:string, name:string }[]>,
    default: () => [],
  },
}

@Component({ components })
export default class DraggableItems extends Vue.extend({ props }) {
  get $leftFields () {
    return this.leftFields
  }

  set $leftFields (newValue) {
    this.$emit('update:leftFields', newValue)
  }

  get $rightFields () {
    return this.rightFields
  }

  set $rightFields (newValue) {
    this.$emit('update:rightFields', newValue)
  }
}

</script>

<style scoped>

.placeholder {
  font-style: italic;
}

.list-group-item {
  cursor: move;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 9px;
  padding-right: 9px;
}

</style>
